<template>
  <cx-showcase-section :name="name" :link="link">
    <div>
      <h2 class="cxu-mb-10 cxu-mt-30">Common Controls Using CxTextArea</h2>
      <div class="cxu-pb-5"><cx-text-area label="Default text area" v-model="inputTextArea"/></div>
      <div class="cxu-pb-5"><cx-text-area label="Disabled text area" v-model="inputTextArea" :disabled="true"/></div>
      <div class="cxu-pb-5"><cx-text-area label="Readonly text area" v-model="inputTextArea" :readonly="true"/></div>
      <div class="cxu-pb-5"><cx-text-area label="Tooltip text area" tooltip="Test tooltip" v-model="inputTextArea" :readonly="false"/></div>
    </div>
  </cx-showcase-section>
</template>

<script>
import CxShowcaseSection from '../CxShowcaseSection';
import CxTextArea from '@/components/CxTextArea';

export default {
  name: 'CxTextAreaShowcase',
  components: {
    CxShowcaseSection,
    CxTextArea,
  },
  data() {
    return {
      name: 'CxTextarea',
      link: '',
      inputTextArea: 'Lorem ipsum dolor  sit amet,\n consectetur adipiscing  elit. Nunc luctus vulputate sem,\n sit amet varius felis luctus a. Fusce viverra mi elit, id aliquam enim varius vitae. Quisque et nunc lacus. Sed commodo urna a pulvinar varius. Nunc tempor vitae massa non. ',
    };
  }
};

</script>
